
<svg
  aria-hidden="true"
  class="my-24 mx-16 fill-brand"
  width="30"
  height="30"
  viewBox="0 0 30 30"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 0H5V2H2C0.89543 2 0 2.89543 0 4V28C0 29.1046 0.89543 30 2 30H28C29.1046 30 30 29.1046 30 28V4C30 2.89543 29.1046 2 28 2H25V0H23V2H7V0ZM23 4H25H28V6H2V4H5H7H23ZM2 8V28H28V8H2ZM16.0337 24H6.72771V23.568L11.5877 18.438C12.8117 17.142 13.5497 16.008 13.5497 14.784C13.5497 13.578 12.8657 12.822 11.6237 12.822C10.3457 12.822 9.53572 13.56 9.31971 15.378H7.12371C7.28571 12.57 8.97771 10.95 11.6957 10.95C14.3597 10.95 15.9437 12.48 15.9437 14.748C15.9437 16.422 14.9537 17.88 13.4237 19.356L10.5617 22.146H16.0337V24ZM19.9449 13.506V24H22.3569V11.13H20.2149L17.2269 13.254V15.36L19.9449 13.506Z"
  />
</svg>
